import Naws from './Naws';

type dataApi = 'GOA' | 'NAWS';

const getDataFeed = (dataApi: dataApi): any => {
  if (dataApi === 'GOA') {
    throw new Error('Deprecated GOA API is not supported.');
  }

  return Naws;
};

export default {
  getDataFeed,
};
